import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import currentAccountService from '../services/currentAccountService';

const CurrentAccountFormPage = () => {
  const [formData, setFormData] = useState({
    account_type: 'musteri',
    company_name: '',
    authorized_person: '',
    email: '',
    phone: '',
    address: '',
    tax_number: '',
    tax_office: ''
  });
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      // Düzenleme modu, verileri çek
      const fetchAccount = async () => {
        try {
          const data = await currentAccountService.getById(id);
          setFormData(data);
        } catch (error) {
          toast.error('Cari bilgileri alınamadı.');
          navigate('/current-accounts');
        }
      };
      fetchAccount();
    }
  }, [id, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await currentAccountService.update(id, formData);
        toast.success('Cari hesap güncellendi.');
      } else {
        await currentAccountService.create(formData);
        toast.success('Cari hesap oluşturuldu.');
      }
      navigate('/current-accounts');
    } catch (error) {
      toast.error(error.response?.data?.message || 'İşlem başarısız.');
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <h4 className="mb-0">{id ? 'Cari Düzenle' : 'Yeni Cari Ekle'}</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Hesap Tipi</label>
                <select name="account_type" className="form-select" value={formData.account_type} onChange={handleChange}>
                  <option value="musteri">Müşteri</option>
                  <option value="tedarikci">Tedarikçi</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Firma Adı / Ünvan</label>
                <input type="text" name="company_name" className="form-control" value={formData.company_name} onChange={handleChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Yetkili Kişi</label>
                <input type="text" name="authorized_person" className="form-control" value={formData.authorized_person} onChange={handleChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">E-posta</label>
                <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Telefon</label>
                <input type="text" name="phone" className="form-control" value={formData.phone} onChange={handleChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Vergi No</label>
                <input type="text" name="tax_number" className="form-control" value={formData.tax_number} onChange={handleChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Vergi Dairesi</label>
                <input type="text" name="tax_office" className="form-control" value={formData.tax_office} onChange={handleChange} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Adres</label>
                <textarea name="address" className="form-control" rows="3" value={formData.address} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" onClick={() => navigate('/current-accounts')} className="btn btn-secondary me-2">İptal</button>
              <button type="submit" className="btn btn-primary">Kaydet</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CurrentAccountFormPage;
